import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, objectSpread2 as _objectSpread2, typeof as _typeof, asyncToGenerator as _asyncToGenerator, createClass as _createClass } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _pt from '../../../node_modules/prop-types/index.js';
import React from 'react';
import { connect } from 'react-redux';
import { FormBuilderResetStateType } from '../types.js';
import { compareParams } from '../../../modules/utility/params.js';
import { abortableApi } from '../../../modules/abort/actions.js';

var ALL_FORM_RESET_OPTIONS = [FormBuilderResetStateType.Data, FormBuilderResetStateType.ReadOnly];

var FormBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FormBase, _React$Component);

  var _super = _createSuper(FormBase);

  function FormBase(_props) {
    var _this;

    _classCallCheck(this, FormBase);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "defaultCommonState", function () {
      return {
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultDataState", function (props) {
      return {
        formData: props.value || props.initialData,
        readOnlyData: props.value || props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultReadOnlyState", function (props) {
      return {
        readOnly: !!props.initialReadOnly
      };
    });

    _defineProperty(_assertThisInitialized(_this), "defaultInitialState", function (props) {
      return _objectSpread2(_objectSpread2(_objectSpread2({
        formValid: true
      }, _this.defaultCommonState()), _this.defaultDataState(props)), _this.defaultReadOnlyState(props));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2(_objectSpread2(_objectSpread2({}, _this.defaultCommonState()), resetOptions.includes(FormBuilderResetStateType.Data) ? _this.defaultDataState(props) : {}), resetOptions.includes(FormBuilderResetStateType.ReadOnly) ? _this.defaultReadOnlyState(props) : {});
    });

    _defineProperty(_assertThisInitialized(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_FORM_RESET_OPTIONS;
      return _typeof(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_loadingKey", undefined);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          value = _this$props.value,
          loadParams = _this$props.loadParams;

      if (value && value !== prevProps.value) {
        _this.setState({
          formData: value
        });
      }

      if (!compareParams(loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _formData, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;

              if (onLoad) {
                _formData = onLoad(loadParams);

                _this.setState({
                  formData: _formData,
                  readOnlyData: _formData
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  formData: loadResponse,
                  readOnlyData: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onFormChange", function (field, data, applyChanges, metadata) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state.formData);
        }
      };

      if (_this.props.onApplyChanges) {
        _this.props.onApplyChanges(field, data, applyChanges, metadata);
      }

      _this.setState(function (state) {
        var newFormData = applyChanges(state.formData);
        var newDirty = state.dirty || !!_this.props.isDirtyChange(field, data, metadata);

        if (newFormData === state.formData && newDirty === state.dirty) {
          return null;
        }

        return {
          formData: newFormData,
          dirty: newDirty
        };
      }, onStateUpdated);
    });

    _defineProperty(_assertThisInitialized(_this), "onFormValidated", function (formValid) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onValidated) {
          _this.props.onValidated(formValid);
        }
      };

      _this.setState({
        formValid: formValid
      }, onStateUpdated);
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options) {
        var _this$props3, submitAction, _submitParams, submitSlowDelay, onSubmit, onSubmitted, loadAction, _loadParams, loadTransform, onLoad, onLoaded, reloadOnSubmit, dispatch, slowTimeout, _submitResponse, submittingAction, _yield$dispatch2, success, error, response, reloadOption, resetOptions, resetState, defaultState, _formData2, _loadResponse, loadingKey, loadingAction, _yield$dispatch3, _success, _error, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.formValid) {
                  _context2.next = 4;
                  break;
                }

                _this.setState({
                  showErrors: true
                });

                _context2.next = 59;
                break;

              case 4:
                _this$props3 = _this.props, submitAction = _this$props3.submitAction, _submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, loadAction = _this$props3.loadAction, _loadParams = _this$props3.loadParams, loadTransform = _this$props3.loadTransform, onLoad = _this$props3.onLoad, onLoaded = _this$props3.onLoaded, reloadOnSubmit = _this$props3.reloadOnSubmit, dispatch = _this$props3.dispatch;
                slowTimeout = null;

                if (onSubmit) {
                  onSubmit(_this.state.formData, _submitParams);
                }

                _submitResponse = undefined;

                if (!submitAction) {
                  _context2.next = 28;
                  break;
                }

                submittingAction = abortableApi(submitAction(_this.state.formData, _submitParams));

                _this.setState({
                  submittingAbort: submittingAction.abort,
                  submitting: true,
                  error: undefined
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 14;
                return dispatch(submittingAction);

              case 14:
                _yield$dispatch2 = _context2.sent;
                success = _yield$dispatch2.success;
                error = _yield$dispatch2.error;
                response = _yield$dispatch2.response;
                if (!loadAction || !_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 21;
                  break;
                }

                return _context2.abrupt("return");

              case 21:
                if (success) {
                  _context2.next = 26;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 26:
                _submitResponse = response;

                _this.setState({
                  readOnlyData: _this.state.formData
                });

              case 28:
                if (onSubmitted) {
                  onSubmitted(_submitResponse, _submitParams, {
                    data: _this.state.formData,
                    options: options
                  });
                } // prevent state changes after unmounting


                if (_this._isMounted) {
                  _context2.next = 31;
                  break;
                }

                return _context2.abrupt("return");

              case 31:
                reloadOption = _this.parseReloadOption(options, !!reloadOnSubmit); // for legacy compatibility

                resetOptions = _this.parseResetOptions(options, []);

                if (reloadOption) {
                  _context2.next = 40;
                  break;
                }

                if (!(resetOptions.length > 0)) {
                  _context2.next = 38;
                  break;
                }

                resetState = _this.defaultResetState(_this.props, resetOptions);

                _this.setState(function (prevState) {
                  return _objectSpread2(_objectSpread2({}, prevState), resetState);
                });

                return _context2.abrupt("return");

              case 38:
                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  dirty: false
                });

                return _context2.abrupt("return");

              case 40:
                // re-load the form with latest data
                defaultState = _this.defaultResetState(_this.props, resetOptions.length > 0 ? resetOptions : ALL_FORM_RESET_OPTIONS);

                if (onLoad) {
                  _formData2 = onLoad(_loadParams);

                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      formData: _formData2,
                      readOnlyData: _formData2
                    });
                  });
                }

                _loadResponse = undefined;

                if (!loadAction) {
                  _context2.next = 58;
                  break;
                }

                loadingKey = _this._loadingKey = Date.now();
                loadingAction = abortableApi(loadAction(_loadParams));
                _context2.next = 48;
                return dispatch(loadingAction);

              case 48:
                _yield$dispatch3 = _context2.sent;
                _success = _yield$dispatch3.success;
                _error = _yield$dispatch3.error;
                _response = _yield$dispatch3.response;
                if (slowTimeout) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 55;
                  break;
                }

                return _context2.abrupt("return");

              case 55:
                if (!(loadingKey !== _this._loadingKey)) {
                  _context2.next = 57;
                  break;
                }

                return _context2.abrupt("return");

              case 57:
                if (!_success) {
                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      error: _error
                    });
                  });
                } else {
                  if (_response) {
                    _loadResponse = loadTransform(_response);
                  }

                  _this.setState(function (prevState) {
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, prevState), defaultState), {}, {
                      formData: _loadResponse !== undefined ? _loadResponse : prevState.formData,
                      readOnlyData: _loadResponse !== undefined ? _loadResponse : prevState.readOnlyData
                    });
                  });
                }

              case 58:
                if (onLoaded) onLoaded(_loadResponse, _loadParams);

              case 59:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleReadOnly", function () {
      var _this$state = _this.state,
          readOnly = _this$state.readOnly,
          readOnlyData = _this$state.readOnlyData,
          formData = _this$state.formData;

      if (readOnly) {
        _this.setState({
          readOnly: false,
          readOnlyData: formData
        });
      } else {
        // revert to data when previously read-only if known
        _this.setState({
          readOnly: true,
          formData: readOnlyData || formData
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty(_assertThisInitialized(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass(FormBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          submitting = _this$state2.submitting,
          slowSubmitting = _this$state2.slowSubmitting,
          formData = _this$state2.formData,
          formValid = _this$state2.formValid,
          error = _this$state2.error,
          showErrors = _this$state2.showErrors,
          dirty = _this$state2.dirty,
          readOnly = _this$state2.readOnly;
      var formProps = {
        value: formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors && !readOnly,
        readOnly: readOnly
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        formValid: formValid,
        error: error,
        dirty: dirty,
        readOnly: readOnly,
        initialData: this.props.initialData
      };
      var events = {
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onToggleReadOnly: this.onToggleReadOnly,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(formProps, state, events);
    }
  }]);

  return FormBase;
}(React.Component);

_defineProperty(FormBase, "propTypes", {
  initialData: _pt.any.isRequired,
  initialReadOnly: _pt.bool.isRequired,
  value: _pt.any,
  loadAction: _pt.func,
  loadParams: _pt.any,
  loadTransform: _pt.func.isRequired,
  loadSlowDelay: _pt.number.isRequired,
  onLoad: _pt.func,
  onLoaded: _pt.func,
  reloadOnSubmit: _pt.bool,
  submitAction: _pt.func,
  submitParams: _pt.any,
  submitSlowDelay: _pt.number.isRequired,
  onSubmit: _pt.func,
  onSubmitted: _pt.func,
  onChange: _pt.func,
  onApplyChanges: _pt.any,
  onValidated: _pt.func,
  isDirtyChange: _pt.func.isRequired,
  render: _pt.func.isRequired,
  abortSubmitOnUnmount: _pt.bool.isRequired,
  dispatch: _pt.any.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase = function connectBase() {
  return connect(null, mapDispatchToProps)(FormBase);
};

var FormBaseComponent = connectBase();

var FormBase$1 = function FormBase$1(props) {
  return /*#__PURE__*/React.createElement(FormBaseComponent, props);
};

export { FormBase$1 as default };
